export enum TopTenSearchtermRange {
    MAIN = 'main',
    COMPARE = 'compare',
    YESTERDAY = 'yesterday',
}



// WEBPACK FOOTER //
// ./src/types/Dashboard.ts